<div class="main-wrapper">
	<div class="main-content">
		<!-- global markup for header -->
		<header class="header">
			<div class="content">
				<div class="header__block row">
					<div class="header__arrow col image" (click)="BackToAdmin()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>

					<div class="header__title col">ביקורים</div>
					<div class="header__burger col image">
						<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
					</div>
				</div>
			</div>

			<div class="report-table__row">
				<div style="width: 99%; margin: auto">
					<!-- <table style="width: 99%; margin: auto">
						<tr>
							<th>
								<form [formGroup]="form" *ngIf="isAdmin">
									<div style="margin-bottom: 5px">בחר סוכן</div>
									<select formControlName="Agent" style="height: 30px">
										<option value="all">הכל</option>
										<option *ngFor="let a of Agents" value="{{ a.AgentID }}">{{ a.AgentID }} - {{ a.UserName }}</option>
									</select>
								</form>
							</th>
							<th>
								<form [formGroup]="form">
									<div style="margin-bottom: 5px">בחר לקוח</div>
									<select formControlName="Name" style="height: 30px">
										<option value="all">הכל</option>
										<option *ngFor="let raa of Names" value="{{ raa.ClientID }}">{{ raa.Client_Name }}</option>
									</select>
								</form>
							</th>
							<th>
								<form [formGroup]="form">
									<div style="margin-bottom: 5px">בחר תאריך</div>
									<select formControlName="Date" style="height: 30px">
										<option value="all">הכל</option>
										<option *ngFor="let raa of Dates" value="{{ raa }}">
											{{ raa | date : 'dd.MM.yyyy' }}
										</option>
									</select>
								</form>
							</th>
						</tr>
					</table> -->
				</div>
				<!-- <div class="header__search header__search_small" style="width: 99%;margin: auto;margin-top: 10px;">
            <form [formGroup]="form" (keyup)="SearchClient()"  >
            <input class="header__search-input" type="text" placeholder="חפש לקוח" formControlName="ClientSearch" style="text-align: center;">
          </form>
            <button class="header__clear-icon" (click)="SearchClear()"></button>
          </div> -->
			</div>

			<!-- <hr style="margin-top: 10px;"> -->
		</header>

		<!-- shop return activity markup -->
		<section class="shop-activity" style="margin-top: 140px">
			<div class="flex-row">
				<div class="flex gap" *ngIf="(_device.isWebview$ | async) === false">
					<app-excel-button onlyEmit (clicked)="downloadExcel()"></app-excel-button>
					<mat-radio-group color="primary" [formControl]="radioControl" class="justify-align-center gap" dir="rtl">
						<mat-radio-button value="basic">בסיסי</mat-radio-button>
						<mat-radio-button value="detailed">מפורט</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="report-table__button filters" (click)="showFilterPopup = !showFilterPopup">סינון</div>
			</div>
			<!-- <div class="report-table__row report-table__row_full-width" > -->
			<div class="report-table__row" style="overflow-x: auto">
				<table class="report-table__table" cellspacing="0" style="margin: 0 auto; width: min(100%, 1000px)">
					<thead class="report-table__table-head">
						<tr>
							<th class="report-table__table-head-name sortable-clickable" style="width: 110px" (click)="translateForSort('CreateDate', 'First')">תאריך</th>
							<th class="report-table__table-head-name sortable-clickable" style="width: 150px" (click)="translateForSort('Client_Name', 'First')">לקוח</th>
							<th
								class="report-table__table-head-name sortable-clickable"
								*ngIf="hasAtLeastOneActiveWithCustomFieldsAndClientName"
								style="width: 120px"
								(click)="translateForSort('ResDesc', 'First')"
							>
								שם לקוח
							</th>
							<th class="report-table__table-head-name sortable-clickable" style="width: 120px" (click)="translateForSort('ResDesc', 'First')">סיכום ביקור</th>
							<th class="report-table__table-head-name sortable-clickable" style="width: 60px" *ngIf="isAdmin" (click)="translateForSort('AgentID', 'First')">סוכן</th>
							<th class="report-table__table-head-name sortable-clickable" style="width: 60px" *ngIf="hasVisitsPictures">תמונה</th>
						</tr>
					</thead>
					<tbody class="report-table__table-body">
						<tr *ngFor="let b of visitsDisplay$ | async; trackBy: trackBy" (click)="openPopup(b)" class="border-bottom-black">
							<td class="report-table__table-body-name">{{ b.CreateDate | date : 'dd.MM.yyyy' }}</td>
							<td class="report-table__table-body-name">{{ b.Client_Name ?? b.ClientName }}</td>
							<td class="report-table__table-body-name" *ngIf="hasAtLeastOneActiveWithCustomFieldsAndClientName">{{ b.string?.clientName || '' }}</td>
							<td class="report-table__table-body-name">{{ b.ResDesc }}</td>
							<td class="report-table__table-body-name" *ngIf="isAdmin">{{ b.AgentID }}</td>
							<td class="report-table__table-body-name" *ngIf="hasVisitsPictures">
								<ng-container *ngIf="b.PicName && b.PicName !== '0'">
									<div class="report-table__button" (click)="_util.stopEventPropogation($event)">
										<a
											*ngIf="(_device.isWebview$ | async) || (_device.isNotDesktopResolution$ | async); else openInNewTabBlock"
											[href]="_ss.CustomerInformation.CustServer + '/mobil/download-visits-picture/' + b.PicName"
											target="_blank"
										>
											הורד
										</a>
										<ng-template #openInNewTabBlock><a [href]="_ss.CustomerInformation.CustServer + '/' + b.PicName" target="_blank">פתח</a></ng-template>
									</div>
								</ng-container>
							</td>
						</tr>
					</tbody>
				</table>

				<!-- <h1 *ngIf="Second && loading">טוען...</h1> -->
			</div>
		</section>
		<!-- end shop return activity markup -->
	</div>
</div>

<div class="popup" *ngIf="isPopupOpen" style="z-index: 555">
	<div class="overlay" (click)="handleClosePopup()"></div>

	<div class="product-detail__title" *ngIf="selectedActive?.Client_Name ?? selectedActive?.ClientName">
		{{ selectedActive?.Client_Name ?? selectedActive?.ClientName }}
	</div>

	<div class="product-detail-popup popup__content">
		<div class="popup__close" (click)="handleClosePopup()" style="width: 30px; height: 30px; background-color: black"></div>
		<div class="product-detail__wrapper">
			<ng-container *ngIf="isActiveWithCustomFields(selectedActive); else normalPopup">
				<div class="popup-row">
					<span class="bold">תאריך:</span> <span>{{ selectedActive.string.date | date : 'dd.MM.yyyy' }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">שם לקוח:</span> <span>{{ selectedActive.string.clientName }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">שם איש קשר+טלפון:</span> <span>{{ selectedActive.string.contactName }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">עיר:</span> <span>{{ selectedActive.string.city }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">תחום:</span> <span>{{ selectedActive.string.subject }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">בטיפול:</span> <span>{{ selectedActive.string.handledBy }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">מהות הפגישה:</span> <span>{{ selectedActive.string.reasonOf }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">כניסה:</span> <span>{{ selectedActive.string.Enter | date : 'HH:mm' : 'Asia/Jerusalem' }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">יציאה:</span> <span>{{ selectedActive.string.Exit | date : 'HH:mm' : 'Asia/Jerusalem' }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">פירוט הפגישה:</span> <span>{{ selectedActive.string.details }}</span>
				</div>
			</ng-container>
			<ng-template #normalPopup>
				<div class="popup-row">
					<span class="bold">תאריך:</span> <span>{{ selectedActive.CreateDate | date : 'dd.MM.yyyy' }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">סיכום ביקור:</span> <span>{{ selectedActive.ResDesc }}</span>
				</div>
				<div class="popup-row" *ngIf="isAdmin">
					<span class="bold">סוכן:</span> <span>{{ selectedActive.AgentID }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">קוד לקוח:</span> <span>{{ selectedActive.ClientID }}</span>
				</div>
				<div class="popup-row" *ngIf="!hasString">
					<span class="bold">שעה:</span> <span>{{ selectedActive.CreateDate | date : 'HH:mm' : 'GMT' }}</span>
				</div>
				<div class="popup-row" *ngIf="hasString">
					<span class="bold">כניסה:</span> <span>{{ selectedActive.string.Enter | date : 'HH:mm' : 'Asia/Jerusalem' }}</span>
				</div>
				<div class="popup-row" *ngIf="hasString">
					<span class="bold">יציאה:</span> <span>{{ selectedActive.string.Exit | date : 'HH:mm' : 'Asia/Jerusalem' }}</span>
				</div>
				<div class="popup-row">
					<span class="bold">פירוט:</span> <span>{{ selectedActive.Remark }}</span>
				</div>
				<div class="popup-row" *ngIf="hasReasonVisitText">
					<span class="bold">סיבת ביקור:</span> <span>{{ selectedActive.ResonVisitText }}</span>
				</div>
				<div class="popup-row" *ngIf="selectedActive.Ldt">
					<span class="bold">הזמנה אחרונה:</span> <span>{{ selectedActive.Ldt }}</span>
				</div>
			</ng-template>
		</div>
	</div>
</div>

<div class="popup" *ngIf="showFilterPopup">
	<div class="overlay"></div>
	<div class="popup__close" (click)="showFilterPopup = false" style="top: 2em; z-index: 1002; box-shadow: inset 0px 0px 2px, 0 0 3px 2px" [style.left]="isTabletAndUpResolution ? '43%' : '2em'"></div>
	<div class="report-table-popup report-table-popup_sort popup__content" style="overflow-y: scroll">
		<div class="report-table-popup__header rtl">
			<div class="report-table-popup__header-title">סינון מתקדם</div>
		</div>
		<div class="report-table-popup__wrapper">
			<div class="report-table-popup__content flex flex-column justify-center align-center">
				<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border report-table-popup__row_padding"></div>
				<div class="report-table-popup__row report-table-popup__row_no-border report-table-popup__row_double">
					<!-- <div class="report-table-popup__box">
						<span class="report-table-popup__content-title">בחירת תקופה</span>
						<div class="report-table-popup__row report-table-popup__row_padding-bottom">
							<label class="report-table-popup__label">
								<div class="report-table-popup__label-title report-table-popup__label-title_gray">מתאריך</div>
								<form [formGroup]="form">
								</form>
							</label>
						</div>
						<div class="report-table-popup__row report-table-popup__row_padding-bottom">
							<label class="report-table-popup__label">
								<div class="report-table-popup__label-title report-table-popup__label-title_gray">עד תאריך</div>
								<form [formGroup]="form">
								</form>
							</label>
						</div>
					</div> -->
					<form [formGroup]="form" dir="rtl">
						<!-- <mat-form-field color="primary">
							<mat-label>תקופה</mat-label>
							<input readonly="true" formControlName="Date" (dateChange)="ChooseDate()" matInput [matDatepicker]="picker" [matDatepickerFilter]="dateFilterFunction" (click)="picker.open()" />
							<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-datepicker #picker></mat-datepicker>
							<mat-error *ngIf="form.controls.from.invalid">תאריך אינו תקין</mat-error>
						</mat-form-field> -->
						<mat-form-field color="primary" class="row">
							<mat-label>לפי תאריכים</mat-label>
							<mat-date-range-input [dateFilter]="dateFilterFunction" [rangePicker]="picker" (click)="picker.open()">
								<input matStartDate readonly="true" formControlName="from" />
								<input matEndDate readonly="true" formControlName="to" />
							</mat-date-range-input>
							<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-date-range-picker #picker></mat-date-range-picker>
							<mat-error *ngIf="form.controls.from.invalid">תאריך אינו תקין</mat-error>
						</mat-form-field>
						<mat-form-field class="row">
							<mat-label>לפי לקוח</mat-label>
							<mat-select formControlName="Name">
								<mat-option value="all">הכל</mat-option>
								<mat-option *ngFor="let raa of Names" [value]="raa.ClientID">{{ raa.Client_Name }}</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field class="row" *ngIf="isAdmin">
							<mat-label>לפי סוכן</mat-label>
							<mat-select formControlName="Agent">
								<mat-option value="all">הכל</mat-option>
								<mat-option *ngFor="let a of Agents" [value]="a.AgentID">{{ a.AgentID }} - {{ a.UserName }}</mat-option>
							</mat-select>
						</mat-form-field>
					</form>
					<!-- <app-mobilitydashbord-filter-box
						*ngFor="let filter of filters"
						[form]="form"
						[title]="filter.title"
						[controlValues]="filter.controlValues"
						[formControlNameFilter]="filter.formControlName"
					></app-mobilitydashbord-filter-box> -->
				</div>
				<div class="report-table-popup__button-wrapper">
					<!-- <button class="report-table-popup__button" [attr.disabled]="dateInvalid ? true : null" [ngClass]="{ darken: dateInvalid }" (click)="handleAdvancedSearch()">הצג תוצאות</button> -->
					<button mat-raised-button color="primary" (click)="resetFilters()">אפס סינונים</button>
				</div>
			</div>
		</div>
	</div>
</div>
